import React from 'react';
import PropTypes from 'prop-types';

import {Box, CircularProgress, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

import AgentJobDraftCard from './AgentJobDraftCard';
import {sortAgentJobsByExecutionTime} from '../agentJobTypeUtils';

const AgentJobsDraft = (props) => {
  const {
    agentJobs,
    loading,
    loadFailed,
    onCancelJob,
    onConfirmJob,
    onSaveJob,
    onSendJobNow,
    participantDetails = {},
  } = props;

  const sortedJobs = React.useMemo(() => sortAgentJobsByExecutionTime(agentJobs), [agentJobs]);

  if (loading && agentJobs.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: 2,
        }}
      >
        <CircularProgress size={22} />
      </Box>
    );
  }

  if (loadFailed) {
    return (
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#D34A2C',
        }}
      >
        <Translate expression='case.Detail.AgentJobs.LoadFailed' />
      </Typography>
    );
  }

  if (agentJobs.length === 0) {
    return null;
  }

  return (
    <Stack sx={{gap: 1.5}}>
      {
        sortedJobs.map((job) => (
          <AgentJobDraftCard
            key={job.agentJobRn}
            job={job}
            onCancelJob={onCancelJob}
            onConfirmJob={onConfirmJob}
            onSaveJob={onSaveJob}
            onSendJobNow={onSendJobNow}
            participantDetails={participantDetails}
          />
        ))
      }
    </Stack>
  );
};

AgentJobsDraft.propTypes = {
  agentJobs: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  loadFailed: PropTypes.bool,
  onCancelJob: PropTypes.func.isRequired,
  onConfirmJob: PropTypes.func.isRequired,
  onSaveJob: PropTypes.func.isRequired,
  onSendJobNow: PropTypes.func.isRequired,
  participantDetails: PropTypes.object,
};

export default React.memo(AgentJobsDraft);
